export default __webpack_public_path__ + "static/media/share.90ed3d8c.jpg";